export default state => {
  return {
    buyOrdersAsyncCall: state.orders.aSyncCall,
    buyOrdersResult: state.orders.result,
    buyOrders: state.orders.entities.order
  };
};



// WEBPACK FOOTER //
// ./src/selectors/ordersSelector.js